var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{attrs:{"to":_vm.getTo(_vm.space_id)}},[_c('div',{staticClass:"o-tile"},[_c('img',{attrs:{"src":_vm.img_src}}),_c('h3',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }